import React from 'react';
import PlanSelector from '../../components/PlanSelector';

const FreeTrialStart = ({ subscriptionAction }) => {
    return (
        <div className="border border-blue-200 border-2 p-6 mb-8 md:w-3/4">
            <div className="font-semibold mb-2">Unlock your child's potential</div>
            <div className="mb-4">
                Foster your child's curiosity and love for learning.
                Subscribe to keep going.
            </div>
            <PlanSelector
                context="subscribe"
                surface="free_trial_start"
                defaultPlan="monthly_family"
            />
        </div>
    );
};

export default FreeTrialStart;
